import { Link } from '../../../defaultConfig';
import type { Account } from '../../../generated-types';
import { CommonPaymentStateWithNote } from '../form/CommonPaymentState';

// eslint-disable-next-line import/prefer-default-export
export const getRedirectLinkAvtalegiro = <TState extends CommonPaymentStateWithNote>(
    state: TState,
    targetFromAccount: Account | undefined,
    enabled: boolean,
    avtalegiroLink?: Link,
): string | undefined =>
    state.toAccount?.avtaleGiroSupported && enabled && state.kid
        ? `${avtalegiroLink?.url}?receiverAccountNumber=${state.toAccount?.accountNumber.value}&id=${targetFromAccount?.accountId.value}&kid=${state.kid.value}`
        : undefined;
